export default __webpack_public_path__ + "static/media/iconfinderYoutubeCircle294712.df0063ba.svg";